import { useCallback, useEffect, useState } from "react";
import type { TourneeLiveResponse } from "../types/execution.types";
import { fetchTourneeLive } from "../services/execution.service";

export function useTourneeLiveExecution(tourneeId?: string) {
  const [data, setData] = useState<TourneeLiveResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!tourneeId) return;
    setLoading(true);
    setError(null);
    try {
      const next = await fetchTourneeLive(tourneeId);
      setData(next);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erreur chargement exécution");
    } finally {
      setLoading(false);
    }
  }, [tourneeId]);

  useEffect(() => {
    void refresh();
    if (!tourneeId) return;
    const handle = window.setInterval(() => void refresh(), 15000);
    return () => window.clearInterval(handle);
  }, [refresh, tourneeId]);

  return { data, loading, error, refresh };
}
